<template>
  <section class="property-header">
    <div class="property-header__info">
      <h1 class="property-header__info-name">
        {{property.name}}
      </h1>
      <div v-if="property.avg_rating" class="property-header__info-rating">
        <Rating v-model="property.avg_rating" disabled :cancel="false" readonly>
          <template #officon>
            <span/>
          </template>
        </Rating>
        <span class="property-header__rating-value">{{ Number(property.avg_rating).toFixed(1) }}</span>
        <span class="property-header__reviews-count" v-if="reviewsCount">
          {{ reviewsCount.toLocaleString() }} {{ reviewsCount === 1 ? $t('review') : $t('reviews') }}
        </span>
        <span class="property-header__reviews-count" v-else-if="property.overall_rating">
          {{ Number(property.overall_rating).toFixed(1) }} / 5
        </span>
      </div>
      <button v-if="property.location" class="text-body-2 pt-2 location-link" aria-label="Open map" @click="openMap">
        <span class="icon icon-map-point color-blue pr-2"/>
        <span class="text-body-2 color-dark-grey">
          <span v-if="property.location.address_info">{{property.location.address_info}}</span>
          <span v-else>{{property.location.city_name}}</span>
        </span>
      </button>
    </div>
    <div class="property-header__actions">
<!--      <div>Save</div>-->
<!--      <div>Share</div>-->
    </div>
  </section>
</template>

<script setup lang="ts">

import Rating from 'primevue/rating';
import {useActivityPropertyStore} from '~/store/activityProperty'
import {scrollToElement} from '~/utils/common'

const propertyStore = useActivityPropertyStore()
const property = propertyStore.property

// Supplier review counts only reach us for some origins; fall back to the rating-out-of-5 line.
const reviewsCount = computed(() => Number(property.supplier_reviews_count) || 0)

function openMap() {
  scrollToElement('#PropertyLocation', -100)
}

</script>

<style lang="scss" scoped>
.property-header {
  display: flex;
  .property-header__info {
    flex: 1;

    @media screen and (max-width: 768px) {
      padding-top: 20px;
    }

    .property-header__info-name {
      font-size: 34px;
      font-weight: 700;
      line-height: 52px;
      padding-top: 24px;
      display: flex;
      align-items: center;

      //tablet horizontal
      @media screen and (max-width: 1024px) and (min-width: 769px){
        padding-top: 30px;
        line-height: 1.3;
      }

      //tablet vertical
      @media screen and (max-width: 768px) and (min-width: 431px) {
        padding-top: 8px;
        line-height: 1.4;
      }

      @media screen and (max-width: 430px) {
        font-size: 20px;
        line-height: 32px;
        display: inline-block;
        max-width: calc(100% - 28px);
        margin-top: 0;
        padding-top: 0;
      }

      @media screen and (min-width: 390px) and (max-width: 431px) {
        max-width: 100%;
      }

      .icon-topic-tile-medallions {
        @media screen and (max-width: 768px) {
          position: relative;
        }
      }
    }
    .property-header__info-rating {
      display: flex;
      align-items: center;
      gap: 8px;

      @media screen and (max-width: 1024px) and (min-width: 768px) {
        margin-left: 2px;
        gap: 10px;
      }

      .p-rating {
        @media screen and (max-width: 1024px) {
          gap: 0.36rem;
        }
      }
    }
    .property-header__rating-value {
      font-size: 14px;
      font-weight: 600;
    }
    .property-header__reviews-count {
      font-size: 14px;
      color: var(--dark-grey);
      font-weight: 400;
    }
    .location-link {
      display: flex;
      justify-content: center;
      text-align: left;

      &.pt-2 {
        @media screen and (max-width: 1024px) {
          padding-top: 0.2rem;
        }
      }

      .icon {
        font-size: 18px;
      }
    }
  }
  .property-header__actions {
    display: flex;
  }
}
</style>
